import React from "react";
import { Link } from "react-router-dom";

import "./notFound.scss";
import notFoundImg from "../../assets/imgs/not-found.webp";

const NotFound = () => {
    return (
        <div className="container not-found ">
            <div className="not-found__content">
                <div className="img">
                    <img width={500} src={notFoundImg} alt="" />
                </div>
                <h2>NOT FOUND</h2> <br />
                <h3> Uh-oh, page not found...</h3>
                <Link to="/" className="btn btn__fill-orange">
                    Back to HomePage
                </Link>
            </div>
        </div>
    );
};

export default NotFound;
